<template>
  <div class="carousel-container">
    <div class="carousel" ref="carousel" @transitionend="onTransitionEnd">
      <div
        class="slide"
        v-for="(image, index) in images"
        :key="index"
        :class="{ active: currentIndex === index }"
      >
        <img
          :src="$urlImg(image.imgUrl)"
          alt="Slide Image"
          @click="openUrl(image.externalLink)"
        />
      </div>
    </div>
    <img
      class="carousel-button prev"
      @click="prevSlide"
      src="../assets/image/left.png"
      alt=""
    />
    <img
      class="carousel-button next"
      @click="nextSlide"
      src="../assets/image/right.png"
      alt=""
    />

    <!-- 小圆点指示器 -->
    <div class="indicator-container">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="indicator"
        :class="{ active: currentIndex === index }"
        @click="jumpToSlide(index)"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content: undefined,
      contentMask: undefined,
      // images: [
      //   {
      //     path: require('../assets/image/swiper.png')
      //   },
      //   {
      //     path: require('../assets/image/swiper2.png')
      //   }
      // ],
      currentIndex: undefined,
      isTransitioning: false,
      newExternalLink: "",
    };
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  created() {},
  methods: {
    openUrl(url) {
      window.open(url, "_blank", "noopener,noreferrer");
    },
    onTransitionEnd(event) {
      if (event.target.classList.contains("slide")) {
        this.isTransitioning = false;
      }
    },
    prevSlide() {
      this.stopAutoPlay();
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      // 移除当前活动图片的 active 类
      const currentSlide = this.$refs.carousel.querySelector(".active");
      if (currentSlide) {
        currentSlide.classList.remove("active");
      }
      // 更新当前索引
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
      // 确保新的活动图片添加 active 类
      this.$nextTick(() => {
        const newSlide = this.$refs.carousel.querySelector(
          `.slide:nth-child(${this.currentIndex + 1})`
        );
        this.content = this.images[this.currentIndex]?.title;
        this.contentMask = this.images[this.currentIndex]?.content;
        this.newExternalLink = this.images[this.currentIndex]?.externalLink;
        if (newSlide) {
          newSlide.offsetWidth;
          newSlide.classList.add("active");
          this.startAutoPlay();
        }
      });
    },
    nextSlide() {
      this.stopAutoPlay();
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      // 移除当前活动图片的 active 类
      const currentSlide = this.$refs.carousel.querySelector(".active");

      if (currentSlide) {
        currentSlide.classList.remove("active");
      }
      // 更新当前索引
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      // 确保新的活动图片添加 active 类
      this.$nextTick(() => {
        const newSlide = this.$refs.carousel.querySelector(
          `.slide:nth-child(${this.currentIndex + 1})`
        );
        this.content = this.images[this.currentIndex]?.title;
        this.contentMask = this.images[this.currentIndex]?.content;
        this.newExternalLink = this.images[this.currentIndex]?.externalLink;
        if (newSlide) {
          // // 强制浏览器重排
          newSlide.offsetWidth;
          // 添加 active 类
          newSlide.classList.add("active");
          this.startAutoPlay();
        }
      });
    },
    startAutoPlay() {
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, 8000); // 每3秒切换一次
    },
    stopAutoPlay() {
      clearInterval(this.intervalId);
    },
    jumpToSlide(index) {
      this.stopAutoPlay();
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      const currentSlide = this.$refs.carousel.querySelector(".active");
      if (currentSlide) {
        currentSlide.classList.remove("active");
      }
      this.currentIndex = index;
      this.$nextTick(() => {
        const newSlide = this.$refs.carousel.querySelector(
          `.slide:nth-child(${this.currentIndex + 1})`
        );
        if (newSlide) {
          newSlide.offsetWidth;
          newSlide.classList.add("active");
          this.startAutoPlay();
        }
      });
    },
  },
  mounted() {
    this.$el.addEventListener("transitionend", this.onTransitionEnd);

    // 使用 Vue 的 $nextTick 确保 DOM 已经更新
    this.$nextTick(() => {
      // 延迟一小段时间，让浏览器有机会渲染初始状态
      setTimeout(() => {
        this.currentIndex = 0;
        const firstSlide =
          this.$refs.carousel.querySelector(".slide:first-child");

        if (firstSlide) {
          // 强制浏览器重排
          firstSlide.offsetWidth;
          firstSlide.classList.add("active");
        }
      }, 100);
    });
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
};
</script>
<style scoped lang="scss">
.carousel-container {
  position: relative;
  width: 100%;
  height: 826px;
  overflow: hidden;
  // margin-top: -0.47917rem;
  // z-index: 9999999;

  .carousel-button.prev {
    width: 36px;
    height: 36px;
    position: absolute;
    left: 100px;
    bottom: 381px;
    cursor: pointer;
  }
  .carousel-button.next {
    width: 36px;
    height: 36px;
    position: absolute;
    right: 100px;
    bottom: 381px;
    cursor: pointer;
  }
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: scale(1);
}
.slide.active {
  opacity: 1;
  transition: transform 8s ease-in-out, opacity 0.2s ease-in-out;
  transform: scale(1.1); /* 放大到1.2倍 */
}
.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
// 指示器样式
.indicator-container {
  position: absolute;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px; // 圆点之间的间距
  z-index: 10;
}

.indicator {
  width: 20px;
  height: 20px;
  background-color: rgba(255, 255, 255, 0.5); // 默认颜色
  border-radius: 50%; // 圆形
  cursor: pointer;
  transition: background-color 0.3s ease;

  &.active {
    background-color: #0d7cd6; // 当前活动圆点的颜色
  }
}
</style>
